/**
 *
 * Grid
 *
 */

import React from 'react';
import classnames from 'classnames';
import withStyles from '@fil-react-components/with-styles';

import styles from './Grid.style';

export interface GridProps extends React.HTMLAttributes<HTMLDivElement> {
  direction?: 'grid-x' | 'grid-y';
  margin?: boolean;
  padding?: boolean;
  marginY?: boolean;
  paddingY?: boolean;
  className?: string;
  asCell?: boolean;
  children: React.ReactNode;
  sm?: number | string;
  md?: number | string;
  lg?: number | string;
}

const Grid: React.FC<GridProps> = ({
  direction = 'grid-x',
  margin = false,
  marginY = false,
  padding = false,
  paddingY = false,
  className,
  asCell = false,
  children,
  sm,
  md,
  lg,
  ...otherProps
}) => (
  <div
    className={classnames(className, {
      'grid-margin': margin,
      'grid-margin-y': marginY,
      'grid-padding': padding,
      'grid-padding-y': paddingY,
      'grid-x': direction === 'grid-x',
      'grid-y': direction === 'grid-y',
      cell: asCell,
    })}
    {...otherProps}
  >
    {children}
  </div>
);

Grid.displayName = 'Grid';

export default withStyles(Grid, styles);
